export interface SkmBaris {
  text: string;
}

export interface SkmKondisiPulang {
  tampil: boolean;
  meninggal: boolean;
  meninggal_at: string | null;
  text: string | null;
}

export interface SkmContent {
  tempat_lahir: string;
  narasi_registrasi: string;
  diagnosis: SkmBaris[];
  tindakan: SkmBaris[];
  obat: SkmBaris[];
  kondisi_pulang: SkmKondisiPulang;
  kesimpulan: string;
  atas_nama: string;
  signee_2_user_id: number | null;
  signed_2_at: string | null;
}

export interface SkmAutofill {
  jenis_kunjungan: string;
  unit_id: string;
  narasi_registrasi: string;
  diagnosis: SkmBaris[];
  tindakan: SkmBaris[];
  obat: SkmBaris[];
  kondisi_pulang: SkmKondisiPulang;
  signee_user_id: number | null;
}

export interface SkmRecord {
  id: number;
  register_id: string | number;
  pasien_rm: string | number;
  unit_id: string;
  nomor: string | null;
  surat_date: string | null;
  signee_user_id: number | null;
  creator_user_id: number | null;
  signed_at: string | null;
  is_signed?: boolean;
  content: SkmContent;
  signee?: { id: number; nama: string } | null;
}

export const SKM_ATAS_NAMA_OPSI: string[] = ["Tim Pemeriksa", "Tim Medis"];
